"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("../constant");

var _default = {
  PropTypes: {
    viewport: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    originOnchange: _propTypes.func,
    destinationOnchange: _propTypes.func,
    originOnselect: _propTypes.func,
    destinationOnselect: _propTypes.func,
    defaultDestination: _propTypes.object,
    defaultOrigin: _propTypes.object,
    originItems: _propTypes.array,
    destinationItems: _propTypes.array,
    locale: _propTypes.object,
    originPlaceholder: _propTypes.string,
    destinationPlaceholder: _propTypes.string,
    originLabel: _propTypes.string,
    destinationLabel: _propTypes.string,
    supportOneCharacterSearch: _propTypes.bool,
    onSwapcallback: _propTypes.func,
    dropdownOnClickCallback: _propTypes.func,
    showIconBackground: _propTypes.bool,
    fireGtm: _propTypes.func,
    cityLevelGrouping: _propTypes.bool,
    enableSuggestion: _propTypes.bool
  },
  DefaultProps: {
    viewport: _constant2.DEVICE_TYPE.DESKTOP,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    originLabel: 'From',
    destinationLabel: 'To',
    supportOneCharacterSearch: true,
    showIconBackground: false,
    cityLevelGrouping: false,
    enableSuggestion: false
  }
};
exports.default = _default;